<template>
  <div v-wechat-title="titleTop" class="allBack">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="topBack">
      <img class="backImg" src="/grouptest/score/welcomeTop.png">
      <div v-if="data" class="getGiftRect">
        <van-notice-bar background="transparent" style="height:1.8em;padding:0 5px;" color="#fff">
          <span v-for="(item,index) in data.top" :key="index">
            恭喜
            <van-image style="vertical-align:middle;border:1px solid #fff" width="1.3em" height="1.3em" round :src="item.icon?item.icon:'/img/defaultIcon.jpg'" />
            {{ item.nickName }}{{ item.commodity?'获得 '+item.commodity:'中奖' }}  [{{ getRestTime(item.timeMinutes) }}前]&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <span v-if="data.top.length<=0">
            暂无人中奖,赶快参加活动领取奖品吧!
          </span>
        </van-notice-bar>
      </div>
    </div>
    <div class="baseRect">
      <div class="titleRect">
        <span class="titleBody">活动规则</span>
      </div>
      <div v-if="data" class="body" v-html="data.activity.value.about" />
    </div>
    <div class="baseRect">
      <div class="titleRect">
        <span class="titleBody">奖品列表</span>
      </div>
      <div class="body">
        <div class="giftRectsBack">
          <div v-if="data" class="giftRects">
            <div class="giftIcons">
              <div v-for="(item,index) in data.activity.items" :key="index" class="itemIcon">
                <img src="\grouptest\score\iconTop.png">
                <div class="iconImg">
                  <img :src="item.icon">
                </div>
                <div class="iconTop">
                  <img src="\grouptest\score\iconTop.png">
                </div>
              </div>
            </div>
            <van-row v-for="(item,index) in data.activity.items" :key="index">
              <van-col span="18" class="itemName">Lv{{ item.level+1 }}. {{ item.name }};</van-col>
              <van-col span="6" class="rigth price">￥{{ ShowFloat(item.priceShow,0) }}</van-col>
            </van-row>
          </div>
        </div>
      </div>
    </div>
    <div class="downImg">
      <img src="/grouptest/score/welcomeDown.png">
    </div>
    <div class="emptyRect" />
    <div class="downButtonRect">
      <imageButton
        title="我要参加"
        image="/grouptest/score/buttonOrangeBack.png"
        image-select="/grouptest/score/buttonOrangeBack.png"
        width="40"
        font-color="#000"
        font-select-color="#fff"
        @click="onJoin"
      />
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Image, NoticeBar } from 'vant'
import TopBar from '@/components/TopBar'
import imageButton from '@/components/imageButton'
import { checkActivity } from '@/utils/baseData'
import { getRestTime, ShowFloat, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [NoticeBar.name]: NoticeBar,
    TopBar,
    imageButton
  },
  data() {
    return {
      selectButton: false,
      titleTop: '',
      title: '20200601',
      backurl: '/store/index',
      data: undefined
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.init(() => {
      this.titleTop = GetSysTitle()
    })
  },
  methods: {
    getRestTime,
    ShowMoney,
    ShowFloat,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init(callback) {
      request({
        url: '/Activity/getPieceMoneyGift',
        method: 'get',
        params: { key: 'cool20200601' }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.title = this.data.activity.shortTitle
        if (callback) {
          callback()
        }
      })
    },
    onJoin() {
      if (checkActivity(this.data.activity, true)) {
        this.$router.push('/group/score')
      }
      // MyNotify('success', '我要参加活动', 1000)
    }
  }
}
</script>
<style scoped>
.allBack{
  min-height: 100vh;
  background-color: #4140FE;
}
.topBack{
  position: relative;

}
.topBack .backImg{
    width: 100%;
    display: block;
}
.topBack .getGiftRect{
    position: absolute;
    left: 1em;
    top: 1em;
    width: calc(100vw - 2em);
    height: 1.6em;
    line-height: 1.6em;
    background: #000;
    background: linear-gradient(135deg, transparent 0.15em, #000 0) top left,
    linear-gradient(-135deg, transparent 0.15em, #000 0) top right,
    linear-gradient(-45deg, transparent 0.15em, #000 0) bottom right,
    linear-gradient(45deg, transparent 0.15em, #000 0) bottom left;
    background-size: 51% 51%;
    background-repeat: no-repeat;
    overflow: hidden;

}

.baseRect .body{
  color: #fff;
 margin: 1em;
 font-size: 0.9em;
 line-height: 1.8em;
}
.baseRect  .itemName
{
  color: #000;
  font-weight: 700;
}
.baseRect .body .price
{
  color:#fff;
  font-weight: 700;
}
.giftRectsBack{
  background: #000;
  background: linear-gradient(135deg, transparent 0.3em, #000 0) top left,
  linear-gradient(-135deg, transparent 0.3em, #000 0) top right,
  linear-gradient(-45deg, transparent 0.3em, #000 0) bottom right,
  linear-gradient(45deg, transparent 0.3em, #000 0) bottom left;
  background-size: 51% 51%;
  background-repeat: no-repeat;
  overflow: hidden;
  padding: 2px;
}
.giftRects{
  background: #F9AE3E;
  background: linear-gradient(135deg, transparent 0.27em, #F9AE3E 0) top left,
  linear-gradient(-135deg, transparent 0.27em, #F9AE3E 0) top right,
  linear-gradient(-45deg, transparent 0.27em, #F9AE3E 0) bottom right,
  linear-gradient(45deg, transparent 0.27em, #F9AE3E 0) bottom left;
  background-size: 51% 51%;
  background-repeat: no-repeat;
  overflow: hidden;
  padding: 1em;
}
.giftRects .giftIcons{
   display: flex;

}
.giftRects .giftIcons .itemIcon{
  margin: 0.5em;
  position: relative;
  overflow: hidden;

}
.giftRects .giftIcons .itemIcon img{
  width: 100%;
}
.giftRects .giftIcons .itemIcon .iconImg{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: 5%;
  display: block;
}
.giftRects .giftIcons .itemIcon .iconTop{
  position: absolute;
  left: 0;
  top: 0;
}

.baseRect .titleRect{
  margin: 1em;
  background-image: url(/grouptest/score/line1.png);
  background-size:auto 1.5em;
  height: 1.5em;
  text-align: center;
  line-height: 1.5em;
  position: relative;
}
.baseRect .titleRect .titleBody{
  background-color: #4140FE;
  font-size: 1.2em;
  color: #fff;
  padding: 0.5em 0.5em;
  font-weight: 700;
}

.emptyRect{
  height: 4em;
}
.downButtonRect{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3em;
  background-color: #F9AE3E;
  padding-top: 1em;
}
.downImg{
  margin-top: -1.5em;
}
.downImg img{
  width: 100%;
}
</style>
